const appConfig = {
  stripe_public_key: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
};

export default appConfig;
